const clasifiedTeams = (teams) => {
    const groups = orderByGroups(teams);
    let nextTeams = [];
    for (let i = 0; i < groups.length; i += 2) {
        nextTeams.push(groups[i].teams[0])
        nextTeams.push(groups[i + 1].teams[1])

        nextTeams.push(groups[i + 1].teams[0])
        nextTeams.push(groups[i].teams[1])
    }

    return nextTeams;
}

const orderByGroups = (teams) => {
    let teamsWithGroup = teams.filter(team => team.group);
    let groups = teamsWithGroup.map((team, i) => {
        return team.group;
    })
    groups.sort((a, b) => a.index - b.index);
    groups = [...new Map(groups.map(item => [item.index, item])).values()]

    let groupTeams = [];
    groups.forEach(group => {

        let ts = teams.filter(item => item.group && item.group.index === group.index);
        ts = orderTeams(ts);
        groupTeams.push({
            group: group,
            teams: ts
        })
    });

    return groupTeams
}

const orderTeams = (teams) => {
    teams.sort((a, b) => {
        // 1- points
        const aPts = a.points || -1;
        const bPts = b.points || -1;
        // 2 - goals difference 
        const aDif = (a.goalsF || -1000) - (a.goalsC || 0);
        const bDif = (b.goalsF || -1000) - (b.goalsC || 0);
        // 3 - goals done
        const aGoalF = a.goalsF || -1000;
        const bGoalF = b.goalsF || -1000;
        return bPts - aPts || bDif - aDif || bGoalF - aGoalF;
    });
    return teams;
}



const getTeamStatistic = (teamA, teamB, oldResult, newResult) => {

    let statistic = {
        teamAStatistic: {},
        teamBStatistic: {}
    }

    // played
    let obj = getPlayedChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.played = obj.teamA;
    statistic.teamBStatistic.played = obj.teamB;

    //wins
    obj = getWinsChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.wins = obj.teamA;
    statistic.teamBStatistic.wins = obj.teamB;

    //draw
    obj = getDrawChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.draw = obj.teamA;
    statistic.teamBStatistic.draw = obj.teamB;

    //lost
    obj = getLostChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.lost = obj.teamA;
    statistic.teamBStatistic.lost = obj.teamB;

    //goalsF
    obj = getGoalsFChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.goalsF = obj.teamA;
    statistic.teamBStatistic.goalsF = obj.teamB;

    //goalsC
    obj = getGoalsCChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.goalsC = obj.teamA;
    statistic.teamBStatistic.goalsC = obj.teamB;

    //points
    obj = getPointsChange(teamA, teamB, oldResult, newResult);
    statistic.teamAStatistic.points = obj.teamA;
    statistic.teamBStatistic.points = obj.teamB;

    return statistic;
}


const getPlayedChange = (teamA, teamB, oldResult, newResult) => {

    let obj = {
        teamA: teamA.played || 0,
        teamB: teamB.played || 0
    }

    const oldNull = (!oldResult || oldResult.goalsA == null || oldResult.goalsB == null);
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (oldNull && newNotNull) { // 
        obj.teamA += 1;
        obj.teamB += 1;
    }

    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    const newNull = (!newResult || newResult.goalsA == null || newResult.goalsB == null);
    if (oldNotNull && newNull) { // 
        obj.teamA -= 1;
        obj.teamB -= 1;
    }

    return obj;
}

const getWinsChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.wins || 0,
        teamB: teamB.wins || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA += (oldResult.goalsA > oldResult.goalsB) ? -1 : 0
        obj.teamB += (oldResult.goalsB > oldResult.goalsA) ? -1 : 0
    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += (newResult.goalsA > newResult.goalsB) ? 1 : 0
        obj.teamB += (newResult.goalsB > newResult.goalsA) ? 1 : 0
    }
    return obj;
}

const getDrawChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.draw || 0,
        teamB: teamB.draw || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA += (oldResult.goalsA == oldResult.goalsB) ? -1 : 0
        obj.teamB += (oldResult.goalsB == oldResult.goalsA) ? -1 : 0
    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += (newResult.goalsA == newResult.goalsB) ? 1 : 0
        obj.teamB += (newResult.goalsB == newResult.goalsA) ? 1 : 0
    }
    return obj;
}

const getLostChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.lost || 0,
        teamB: teamB.lost || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA += (oldResult.goalsA < oldResult.goalsB) ? -1 : 0
        obj.teamB += (oldResult.goalsB < oldResult.goalsA) ? -1 : 0
    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += (newResult.goalsA < newResult.goalsB) ? 1 : 0
        obj.teamB += (newResult.goalsB < newResult.goalsA) ? 1 : 0
    }
    return obj;
}

const getGoalsFChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.goalsF || 0,
        teamB: teamB.goalsF || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA -= oldResult.goalsA;
        obj.teamB -= oldResult.goalsB;
    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += newResult.goalsA;
        obj.teamB += newResult.goalsB;
    }
    return obj;
}

const getGoalsCChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.goalsC || 0,
        teamB: teamB.goalsC || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA -= oldResult.goalsB;
        obj.teamB -= oldResult.goalsA;
    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += newResult.goalsB;
        obj.teamB += newResult.goalsA;
    }
    return obj;
}

const getPointsChange = (teamA, teamB, oldResult, newResult) => {
    let obj = {
        teamA: teamA.points || 0,
        teamB: teamB.points || 0
    }
    const oldNotNull = (oldResult && oldResult.goalsA != null && oldResult.goalsB != null);
    if (oldNotNull) {
        obj.teamA -= oldResult.goalsA > oldResult.goalsB ? 3 : 0;
        obj.teamA -= oldResult.goalsA === oldResult.goalsB ? 1 : 0;

        obj.teamB -= oldResult.goalsB > oldResult.goalsA ? 3 : 0;
        obj.teamB -= oldResult.goalsB === oldResult.goalsA ? 1 : 0;

    }
    const newNotNull = (newResult && newResult.goalsA != null && newResult.goalsB != null);
    if (newNotNull) {
        obj.teamA += newResult.goalsA > newResult.goalsB ? 3 : 0;
        obj.teamA += newResult.goalsA === newResult.goalsB ? 1 : 0;

        obj.teamB += newResult.goalsB > newResult.goalsA ? 3 : 0;
        obj.teamB += newResult.goalsB === newResult.goalsA ? 1 : 0;
    }
    return obj;
}


export {
    orderByGroups,
    orderTeams,
    clasifiedTeams,
    getTeamStatistic
};

